import { usePayment } from '$api-clients/hooks';

export function useTaxDocuments({ year }: { year: number }) {
  const { data, isLoading, error } = usePayment('/me/tax-documents', {
    params: {
      query: {
        year,
      },
    },
  });

  return {
    loading: isLoading,
    documents: data?.parties ?? [],
    error: error?.message,
  };
}
